import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SchedaCoopAgricoleFormService } from './scheda-coop-agricole-form.service';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [SchedaCoopAgricoleFormService],
})
export class SchedaCoopAgricoleFormModule {}